import { render, staticRenderFns } from "./AttachmentsH5.vue?vue&type=template&id=ced8abea&scoped=true"
import script from "./AttachmentsH5.vue?vue&type=script&lang=js"
export * from "./AttachmentsH5.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsH5.vue?vue&type=style&index=0&id=ced8abea&prod&lang=scss&scoped=true"
import style1 from "./AttachmentsH5.vue?vue&type=style&index=1&id=ced8abea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced8abea",
  null
  
)

export default component.exports